import React, { useState } from "react";
import ViewOrderModal from "./ViewOrderModal";

function ViewOrder({ item, currency }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleViewOrder = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <td className="py-2 px-4 text-center">
        <button
          onClick={handleViewOrder}
          className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-sm"
        >
          View
        </button>
      </td>
      
      <ViewOrderModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        order={item}
        currency={currency}
      />
    </>
  );
}

export default ViewOrder;
